import React, { useRef } from 'react';
import ReactSelect from 'react-select';

export const MultiSelect = (props) => {
    // isOptionSelected sees previous props.value after onChange
    const valueRef = useRef(props.value);
    valueRef.current = props.value;

    const selectAllOption = {
        value: '<SELECT_ALL>',
        label: 'Összes',
    };

    const isSelectAllSelected2 = () =>
        valueRef.current.length === props.options.length && props.options.length !== 0;

    const isSelectAllSelected = () => {
        if(props.options !== null && props.options !== undefined && valueRef !== null && valueRef !== undefined){
            return valueRef.current.length === props.options.length && props.options.length !== 0;
        }
        else {
            return false;
        }
    }

    const isOptionSelected = (option) =>
        valueRef.current.some(({ value }) => value === option.value) ||
        isSelectAllSelected();

    const getOptions2 = () => [props.options.length !== 0 ? selectAllOption: null, ...props.options];

    const getOptions = () => {
        //console.log(props);
        if(props.options === null || props.options === undefined || (props.options.length === 0)){
            return [];
        }
        else {
            return [selectAllOption, ...props.options];
        }
    }

    const getValue = () =>
        isSelectAllSelected() ? [selectAllOption] : props.value;

    const onChange = (newValue, actionMeta) => {
        const { action, option, removedValue } = actionMeta;

        if (
            action === 'select-option' &&
            option.value === selectAllOption.value
        ) {
            props.onChange(props.options, actionMeta);
        } else if (
            (action === 'deselect-option' &&
                option.value === selectAllOption.value) ||
            (action === 'remove-value' &&
                removedValue.value === selectAllOption.value)
        ) {
            props.onChange([], actionMeta);
        } else if (
            actionMeta.action === 'deselect-option' &&
            isSelectAllSelected()
        ) {
            props.onChange(
                props.options.filter(({ value }) => value !== option.value),
                actionMeta
            );
        } else {
            props.onChange(newValue || [], actionMeta);
        }
    };

    return (
        <ReactSelect
            isOptionSelected={isOptionSelected}
            options={getOptions()}
            value={getValue()}
            onChange={onChange}
            hideSelectedOptions={true}
            closeMenuOnSelect={false}
            isMulti
            className='react-select-container'
            classNamePrefix='react-select'
            placeholder={props.placeholder}
            styles={{
                // Fixes the overlapping problem of the component
                menu: provided => ({ ...provided, zIndex: 9999 })
            }}
        />
    );
};
